import type { HelpFile } from '../../types/help'
import { ToasterTestIds } from '../../../testids/ToasterTestIds'

export const toasterHelp: HelpFile = {
  texts: {
    [ToasterTestIds.toast]: null,
    [ToasterTestIds.toastError]: null,
    [ToasterTestIds.toastEntityLink]: 'Zum kollidierenden Datensatz springen, um seinen aktuellen Wert anzusehen oder zu bearbeiten.',
    [ToasterTestIds.toastErrorLogLink]: 'Den passenden Eintrag im Fehlerprotokoll öffnen, um den vollständigen Kontext und Stack-Trace zu sehen.',
  },
}
